import React from 'react';
import { useNavigate } from 'react-router-dom';
import ApiURL from '../Api/Api';
import { DEFAULT_COMPANY_THEME, applyCompanyTheme } from '../utils/companyTheme';

const LogoutButton = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const response = await fetch(`${ApiURL}/logout.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      const data = await response.json();
      if (data.status === 'success') {
        ['role', 'user_name', 'id', 'company_id', 'package_info', 'package_usage', 'company_branding', 'company_name', 'company_theme_color', 'company_logo_path'].forEach((key) => {
          localStorage.removeItem(key);
        });
        applyCompanyTheme({ theme_color: DEFAULT_COMPANY_THEME });
        // Redirect to login page after logout
        navigate('/');
      } else {
        console.error('Logout failed:', data.message);
      }
    } catch (err) {
      console.error('Error logging out:', err);
    }
  };

  return (
    <button
      onClick={handleLogout}
      className="mx-2 flex w-[calc(100%-1rem)] items-center justify-center rounded-xl bg-rose-600 px-4 py-2 text-sm font-bold text-white transition hover:bg-rose-700"
    >
      Logout
    </button>
  );
};

export default LogoutButton;
